import { BaseContainerModel } from '../base-container.model';
import {
    bl_fi_gen_doc_message_template_comp_link_RowInterface,
    bl_fi_gen_doc_message_template_comp_link_RowClass
  } from '../../dbschema/index';
export class GenericDocMessageTemplateCompLinkContainer extends BaseContainerModel {
    bl_fi_gen_doc_message_template_comp_link:  bl_fi_gen_doc_message_template_comp_link_RowInterface = new bl_fi_gen_doc_message_template_comp_link_RowClass();

}